import React from "react";

export default function CompletedStageDrawer({ entry, stage, onClose }) {
  if (!entry) return null;

  return (
    <div className="drawer-overlay" onClick={onClose}>
      <div className="drawer" onClick={(e) => e.stopPropagation()}>
        <button className="drawer-close" onClick={onClose}>
          ×
        </button>
        <h3>
          {entry.stageName} (Visit #{entry.visitIndex})
        </h3>
        <p>Entered: {new Date(entry.enteredAt).toLocaleString()}</p>
        <p>Completed: {new Date(entry.completedAt).toLocaleString()}</p>
        {entry.taskData && Object.keys(entry.taskData).length > 0 && (
          <div className="drawer-tasks">
            <h4>Tasks</h4>
            <ul>
              {Object.entries(entry.taskData).map(([tid, data]) => {
                const taskDef = stage?.tasks?.find((t) => t.id === tid);
                const label = taskDef ? taskDef.title : tid;
                return (
                  <li key={tid}>
                    <strong>{label}:</strong>{" "}
                    {data.type === "file" ? data.fileName : data.value}
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        <p>
          Transition taken:&nbsp;
          {entry.transitionLabel || "-"}
        </p>
      </div>
    </div>
  );
}
